import { useState as L, useCallback as g, useEffect as p } from "react";
import { useAvailabilities as A } from "./index145.mjs";
import "jotai";
import "@amenitiz/design-system";
const k = () => {
  const [r, a] = L(!1), {
    months: l,
    fetchAvailabilities: i,
    findNextDateToLoad: c,
    isReachLimit: d,
    isWithinLimit: m,
    checkIfAvailable: f,
    getAvailabilityForDate: D,
    getFirstUnavailableDate: h,
    timeLimitCustomMessage: u
  } = A(), o = (t) => {
    const s = t.getMonth() + 2, n = t.getFullYear(), b = s > 11 ? n + 1 : n, v = s % 12;
    return new Date(b, v);
  }, e = g(
    async (t = {}) => {
      a(!0), await i(t, 2), a(!1);
    },
    [i]
  );
  return p(() => {
    e({
      endDate: o(/* @__PURE__ */ new Date())
    });
  }, [e]), {
    months: l,
    isLoading: r,
    isReachLimit: d,
    isWithinLimit: m,
    checkIfAvailable: f,
    getAvailabilityForDate: D,
    getFirstUnavailableDate: h,
    fetchMoreAvailabilities: () => {
      const t = c();
      e({
        startDate: t,
        endDate: o(t)
      });
    },
    timeLimitCustomMessage: u
  };
};
export {
  k as useLoadCarouselCalendar
};
